import React from "react";
import {
    Show,
    SimpleShowLayout,
    RichTextField,
    DateField,
    BooleanField,
    TextField,
    ReferenceField,
    useRecordContext
} from 'react-admin';
import CustomUserNameField from "./user.util";
import {ProviderTypesField} from "./partials/ProviderTypes";

const ProviderTitle = () => {
    const record = useRecordContext();
    return <span>Provider: {record.user.first_name} {record.user.last_name}</span>;
};

export const ProviderShow = props => (
    <Show title={<ProviderTitle />} {...props}>
        <SimpleShowLayout>
            <ReferenceField label="Full Name" source="user_id" reference="admin/user" >
                <CustomUserNameField />
            </ReferenceField>
            <ReferenceField label="Email" source="user_id" reference="admin/user" >
                <TextField source="email" />
            </ReferenceField>
            <TextField source="title" />
            <TextField source="designation" />
            <ProviderTypesField label="Types" />
            <TextField source="acuity_calendar_id" />
            <BooleanField source="is_active" />
            <BooleanField source="self_pay" />
            <RichTextField source="board_certification" />
            <RichTextField source="clinical_experience" />
            <RichTextField source="education" />
            <DateField label="Created At" source="created_at" />
            <DateField label="Updated At" source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
